import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import logo from "../../../assets/images/circular_logo.jpg";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "./FeeReceipt.css"; // Import external CSS

const FeeReceipt = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const feeMonth = queryParams.get("month");
  const feeType = queryParams.get("type");
  const examName = queryParams.get("exam");

  const otherFeeName = queryParams.get("fee_name");
  console.log(otherFeeName);
  const [student, setStudent] = useState({});
  const [feeDetails, setFeeDetails] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state to track fetch completion

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchStudentData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/student/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setStudent(response.data);
        }
      } catch (error) {
        // Handle error
      }
    };

    const fetchFeesDetails = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/fees/payment/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const filteredFeeDetails = response.data.filter((fee) => {
            if (
              feeType === "tuition_fee" &&
              fee.paymentType === "tuition_fee" &&
              fee.month === feeMonth
            ) {
              return true;
            }
            if (
              feeType === "transportation_fee" &&
              fee.paymentType === "transportation_fee" &&
              fee.month === feeMonth
            ) {
              return true;
            }
            if (
              feeType === "exam_fee" &&
              fee.paymentType === "exam_fee" &&
              fee.examName === examName
            ) {
              return true;
            }
            if (
              feeType === "other_fee" &&
              fee.paymentType === "other_fee" &&
              fee.otherFeeName === otherFeeName
            ) {
              return true;
            }
            return false;
          });
          console.log(filteredFeeDetails);

          setFeeDetails(filteredFeeDetails);
          setLoading(false); // Data fetched successfully
        }
      } catch (error) {
        // Handle error
      }
    };

    fetchStudentData();
    fetchFeesDetails();
  }, [id, feeType, feeMonth, examName, otherFeeName]);

  useEffect(() => {
    // Get the current date from the user's computer

    if (!loading && feeDetails.length > 0) {
      // Print the page after the data is loaded
      window.print();
    }
  }, [loading, feeDetails]); // Trigger print when data is ready

  const receiptNo = "12345";
  const cashierSign = "Authorized Signatory";

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.getElementById("receipt"), {
      callback: function (doc) {
        doc.save("FeeReceipt.pdf");
      },
      x: 10,
      y: 10,
    });
  };

  return (
    <>
      <div id="receipt" className="receipt-container">
        <div className="header-receipt">
          <div className="logo-container">
            <img src={logo} alt="School Logo" className="logo" />
          </div>
          <h1 className="school-name">SHINE INTERNATIONAL SCHOOL</h1>
          <p className="school-description">
            A Co-educational, English Medium School Based on CBSE Curriculum
          </p>
          <p className="school-location">JAMUDAG, RANCHI</p>
        </div>

        <div className="details-header">
          <p>
            <strong>Receipt No:</strong>{" "}
            {feeDetails.length > 0 ? feeDetails[0].receipt_number : ""}
          </p>
          <h2>
            <strong>Fee Receipt (Office's Copy)</strong>
          </h2>
          <p>
            <strong>Date:</strong>{" "}
            {feeDetails.length > 0 ? feeDetails[0].date : ""}
          </p>
        </div>

        <div className="student-details">
          <p>
            <strong>Student Name:</strong> {student.student_name}
          </p>
          <p>
            <strong>Student ID:</strong> {student.student_id}
          </p>
          <p>
            <strong>Roll:</strong> {student.class_roll_number}
          </p>
          <p>
            <strong>Class:</strong> {student.student_class}
          </p>
        </div>

        {feeDetails.length > 0 ? (
          feeDetails.map((fee, index) => (
            <div key={index}>
              <table className="fee-table">
                <tbody>
                  <tr>
                    <th className="table-header">Fee Type</th>
                    <td>
                      {fee.paymentType === "exam_fee"
                        ? "Exam Fee"
                        : fee.paymentType === "other_fee"
                        ? "Other Fee"
                        : fee.paymentType === "tuition_fee"
                        ? "Tuition Fee"
                        : "Transportation Fee"}
                    </td>
                  </tr>
                  <tr>
                    <th className="table-header">
                      {fee.paymentType === "exam_fee"
                        ? "Exam Name"
                        : fee.paymentType === "other_fee"
                        ? "Fee Name"
                        : "Month"}
                    </th>
                    <td>
                      {fee.paymentType === "exam_fee" && fee.examName
                        ? fee.examName
                        : fee.paymentType === "other_fee" && fee.otherFeeName
                        ? fee.otherFeeName
                        : fee.month}
                    </td>
                  </tr>
                  <tr>
                    <th className="table-header">Amount</th>
                    <td>{fee.amount}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Paid By</th>
                    <td>{fee.paidBy}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Payment Mode</th>
                    <td>{fee.mode}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Remarks</th>
                    <td>{fee.remark}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <p>No fee details found for the selected filters.</p>
        )}

        <div className="footer-fees">
          <p className="signature">{cashierSign}</p>
          <p className="powered-by">Powered By DevSphire</p>
        </div>
      </div>
      <br />
      <div id="receipt" className="receipt-container">
        <div className="header-receipt">
          <div className="logo-container">
            <img src={logo} alt="School Logo" className="logo" />
          </div>
          <h1 className="school-name">SHINE INTERNATIONAL SCHOOL</h1>
          <p className="school-description">
            A Co-educational, English Medium School Based on CBSE Curriculum
          </p>
          <p className="school-location">JAMUDAG, RANCHI</p>
        </div>

        <div className="details-header">
          <p>
            <strong>Receipt No:</strong>{" "}
            {feeDetails.length > 0 ? feeDetails[0].receipt_number : ""}
          </p>
          <h2>
            <strong>Fee Receipt (Student's Copy)</strong>
          </h2>
          <p>
            <strong>Date:</strong>{" "}
            {feeDetails.length > 0 ? feeDetails[0].date : ""}
          </p>
        </div>

        <div className="student-details">
          <p>
            <strong>Student Name:</strong> {student.student_name}
          </p>
          <p>
            <strong>Student ID:</strong> {student.student_id}
          </p>
          <p>
            <strong>Roll:</strong> {student.class_roll_number}
          </p>
          <p>
            <strong>Class:</strong> {student.student_class}
          </p>
        </div>

        {feeDetails.length > 0 ? (
          feeDetails.map((fee, index) => (
            <div key={index}>
              <table className="fee-table">
                <tbody>
                  <tr>
                    <th className="table-header">Fee Type</th>
                    <td>
                      {fee.paymentType === "exam_fee"
                        ? "Exam Fee"
                        : fee.paymentType === "other_fee"
                        ? "Other Fee"
                        : fee.paymentType === "tuition_fee"
                        ? "Tuition Fee"
                        : "Transportation Fee"}
                    </td>
                  </tr>
                  <tr>
                    <th className="table-header">
                      {fee.paymentType === "exam_fee"
                        ? "Exam Name"
                        : fee.paymentType === "other_fee"
                        ? "Fee Name"
                        : "Month"}
                    </th>
                    <td>
                      {fee.paymentType === "exam_fee" && fee.examName
                        ? fee.examName
                        : fee.paymentType === "other_fee" && fee.otherFeeName
                        ? fee.otherFeeName
                        : fee.month}
                    </td>
                  </tr>
                  <tr>
                    <th className="table-header">Amount</th>
                    <td>{fee.amount}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Paid By</th>
                    <td>{fee.paidBy}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Payment Mode</th>
                    <td>{fee.mode}</td>
                  </tr>
                  <tr>
                    <th className="table-header">Remarks</th>
                    <td>{fee.remark}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <p>No fee details found for the selected filters.</p>
        )}

        <div className="footer-fees">
          <p className="signature">{cashierSign}</p>
          <p className="powered-by">Powered By DevSphire</p>
        </div>
      </div>
    </>
  );
};

export default FeeReceipt;
